<template>
  <div class="content bg8">
    <div class="middled">
      <div class="basehero">
        <h1>We are Focus &amp; Clarity</h1>
        <h2 class="section">
          On a mission to make work matter.          
        </h2>
        <p>
          Foclarity is a SaaS platform that helps organizations align teams around top-level priorities and strategic goals. In an era where misalignment drains time, focus, and morale, Foclarity equips leaders with the tools to drive clarity, alignment, and coordinated execution across their teams.
        </p>

        <section>

          <h2 class="section">
            Michael Ashley, CEO
          </h2>
          <img src="@/assets/mash-michael-ashley.png" alt="Mash Michael Ashley, MBA" style="float:left;margin:0px 15px 0px 0;border-radius:50%;width:140px;height:140px;border:1px solid #ccc;">
          <p>
            Michael “Mash” Ashley is the Founder and CEO of Foclarity, a SaaS platform that helps teams align around top-level priorities and strategic goals. With over 25 years at the intersection of innovation, strategy, and execution, he's co-founded and scaled startups (including four exits), guided dozens of companies from concept to traction, and launched a university-based incubator at San José State University. 
          </p>
          <p>
            Mash’s focus is turning bold ideas into real-world impact through clarity, alignment, and coordinated execution. As an Adjunct Professor at San José State’s College of Business, he combines deep experience with academic rigor, equipping students to tackle complex challenges and think like founders.
          </p>
          <p>
            LinkedIn: <a href="https://www.linkedin.com/in/mashley" target="_blank">Michael (Mash) Ashley</a>.
          </p>

          <h2 class="section">
            Nicole Witt, Product Engineering Manager
          </h2>
          <img src="@/assets/nicole-witt.jpeg" alt="Nicole Witt" style="float:left;margin:0px 15px 0px 0;border-radius:50%;width:140px;height:140px;border:1px solid #ccc;">
          <p>
            As the Product Engineering Manager at Foclarity, Nicole is driving the development of a native iOS app that extends the functionality of our existing web platform using a shared backend API
            and implementing agentic AI systems to optimize onboarding workflows for customers and interns. 
          </p>
          <p>
            Currently mentoring a cross-functional intern team to develop scalable data pipelines that support analytics and reporting across product, marketing, and operations,
            Nicole is also partnering with stakeholders to align technical execution with business objectives, with a focus on building features that address internal and customer pain points.
            Additionally, she is establishing agile development workflows and code review practices to improve release quality and accelerate intern onboarding and team ramp-up.
          </p>
          <p>
            LinkedIn: <a href="https://www.linkedin.com/in/nicolenwitt/" target="_blank">Nicole Witt</a>.
          </p>

          <h2 class="section">
            Julia Padilla, Marketing Associate
          </h2>
          <img src="@/assets/julia-image.jpeg" alt="Julia Padilla" style="float:left;margin:0px 15px 0px 0;border-radius:50%;width:140px;height:140px;border:1px solid #ccc;">
          <p>
            Julia was in our Summer 2024 and Winter 2024 Intern Programs. She joined as an employee in January 2025 and is your first point of contact, handling all your account needs.
          </p>
          <p>
            Recently graduated with an Associates in Business Administration and currently pursuing a Bachelor's degree at SJSU.
            Passionate about marketing and equipped with both academic knowledge and internship experience.
          </p>
          <p>
            LinkedIn: <a href="https://www.linkedin.com/in/julia-padilla-a77aba286/" target="_blank">Julia Padilla</a>.
          </p>
          
          <h2 class="section">
            Denisse Tungol, Marketing Associate
          </h2>
          <img src="@/assets/denisse-image.jpeg" alt="Denisse Tungol" style="float:left;margin:0px 15px 0px 0;border-radius:50%;width:140px;height:140px;border:1px solid #ccc;">
          <p>
            Denisse was in our Spring 2025 Marketing Intern Program and is now an employee leading the design team.
          </p>
          <p>
            A student at SJSU, Denisse is passionate about business, marketing, and especially web design and gaming.
            She is a quick learner and eager to contribute to your marketing success.
          </p>
          <p>
            LinkedIn: <a href="https://www.linkedin.com/in/denisse-tungol-929927248/" target="_blank">Denisse Tungol</a>.
          </p>

          <h2 class="section">
            Lokesh Kumar, Data Analyst Intern
          </h2>
          <img src="@/assets/lokesh-image.jpeg" alt="Lokesh Kumar" style="float:left;margin:0px 15px 0px 0;border-radius:50%;width:140px;height:140px;border:1px solid #ccc;">
          <p>
            Lokesh is in our Summer 2025 Data Analyst Intern Program.
          </p>
          <p>
            Lokesh is a college student who is exploring the intersections of IT, Software engineering, and Management Information Systems (MIS). Currently pursuing Management Information Systems at San Jose State University, I’m actively learning Java, Python, and Excel to strengthen my tech skills. With the goal of Computer Science, I am on the lookout for an internship in IT analysis or software engineering to apply my expanding knowledge to real-world scenarios. Eager to connect with fellow learners, professionals, and mentors in the field of IT and Software Engineering.
          </p>
          <p>
            LinkedIn: <a href="https://www.linkedin.com/in/lokeshikumar/" target="_blank">Lokesh Kumar</a>.
          </p>

          <h2 class="section">
            Neeraj Chandra Penumaka, Data Analyst Intern
          </h2>
          <img src="@/assets/neeraj-image.jpeg" alt="Neeraj" style="float:left;margin:0px 15px 0px 0;border-radius:50%;width:140px;height:140px;border:1px solid #ccc;">
          <p>
            Neeraj is in our Summer 2025 Data Analyst Intern Program.
          </p>
          <p>
            I am an undergraduate student pursuing MIS(Management Information Systems) at San Jose State University, graduating December 2025. My interest is to work at a job that combines both Business and Computer Science principles. I am a firm believer of collaboration and team work because I tend to work better in a team where I can always improve my communication skills and work ethic as circumstances and situations can change over time.
          </p>
          <p>
            LinkedIn: <a href="https://www.linkedin.com/in/neerajcpen/" target="_blank">Neeraj Chandra Penumaka</a>.
          </p>

          <h2 class="section">
            Alice Wu, Graphic Design Intern
          </h2>
          <img src="@/assets/alice-image.jpeg" alt="Alice Wu" style="float:left;margin:0px 15px 0px 0;border-radius:50%;width:140px;height:140px;border:1px solid #ccc;">
          <p>
            Alice is in our Summer 2025 Marketing Intern Program and is your graphic design intern.
          </p>
          <p>
            Hi! I'm Alice, a designer and content creator who blends strategic thinking with visual storytelling. With experience in social media marketing and viral content creation, I've grown audiences through data-driven campaigns (and even created a video with 15M+ views and 3M+ likes!). With UX/UI experience from multiple designathons, hackathons, and my internship at 24/7 TEACH, I specialize in creating user-focused designs that convert scrollers into engagers, visitors into users, and ideas into impactful digital experiences.
          </p>
          <p>
            LinkedIn: <a href="https://www.linkedin.com/in/alice-m-wu/" target="_blank">Alice Wu</a>.
          </p>

        </section>

        <section>
          <p>
            We are hiring. Connect with <a href="https://www.linkedin.com/company/foclarity/" target="_blank">Foclarity on LinkedIn</a> to learn more.
          </p>
        </section>

        <div style="background:#f0f8ff; border:1px solid #ccc;padding:40px;margin: 50px 0 ;">
          <h2 style="text-align: center;">Need help getting started?</h2>
          <p style="text-align: center;">
            Schedule a call and learn how it works.
          </p>
          <p style="text-align: center;">
            <a href="/contact">
                <button class="wide" style="background: #000;"> Schedule a Call </button>
            </a>
          </p>
        </div>

        <div v-show="false">
          <section>
            <h2>Our Story</h2>
            <p>
              We are a team of management consultants who share a vision to revolutionize how companies adapt to change and achieve sustainable growth.
              We are dedicated to helping business leaders accelerate through top-level challenges with enormous impact. 
              Foclarity is our system of frameworks and software, proven to drive growth, retention and customer success with focus, clarity and alignment.
            </p>
          </section>

          <section>
            <h2>Our Expertise</h2>
            <p>
              At Foclarity, we take pride in over 40 years combined experience guiding enterprise companies and startups through major challenges, 
              accelerating growth and success. 
              Our team of seasoned professionals brings a wealth of knowledge and a proven track record of successful transformations in diverse industries.
            </p>
          </section>

          <section>
            <h2>Customer Focus</h2>
            <p>
              Our clients are at the heart of everything we do. 
              At Foclarity, we strive to understand our customers' unique needs and tailor our solutions to address their specific business transformation requirements. 
              Customer success and satisfaction drive us to continuously innovate and deliver exceptional results.
            </p>
          </section>
          
          <section>
            <h2>Company Culture</h2>
            <p>
              At Foclarity, we foster a culture of collaboration, innovation, and continuous learning. 
              Our diverse team of experts shares a passion for creating cutting-edge software solutions that empower leaders to lead successful transformations. 
              We believe that our people are the driving force behind our achievements.
            </p>
          </section>
          
          <section>
            <h2>Social Responsibility</h2>
            <p>
              Giving back to the community is an integral part of our corporate ethos. 
              At Foclarity, we actively engage in various philanthropic initiatives and support causes that drive positive change. 
              Our commitment to social responsibility extends beyond our software, making a meaningful impact on society.
            </p>
          </section>
          
        </div>

      </div>
    </div>    
  </div>
</template>

<script>
import { isLoggedIn } from "../utils/auth";


export default {
  title: 'About Us | Foclarity',
  name: "WhoWeAre",
  mounted: function() {
    if (isLoggedIn()) {
      // this.$router.push("dashboards");
    }
  },
  methods: {
    isLoggedIn() {
      return isLoggedIn();
    }
  },
  components: {},
  data () {
      return {
      }
  },
  created () {
  }
};
</script>

<style lang="scss" scoped>

.heroblue {
  background: linear-gradient(110deg, #00b2ee 60%, #007cee 60%);
  height: 320px;
  margin: -20px -20px 20px -20px;
  border-radius: 4px 4px 0 0;
  @media only screen and (max-width: 440px) {
    border-radius: 0px 0px 0 0;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  & h1 {
    text-align: center;
    color: #fff;
    font-size: 45px;
    max-width: 600px;
    @media (max-width: 415px) {
      font-size: 36px;
      padding: 20px;
    }
  }
  & a {
    text-decoration: none;
    color: #fff;
    & .signupbox {
      text-align: center;
      padding: 8px;
      font-size: 24px;
      font-weight: bold;
      background: #ff7f24;
      width: 300px;
      border-radius: 10px;
      border: 1px solid #fff;
      margin: auto;
    }
  }
}

.row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}

.column {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
  padding: 10px;
  min-width: 200px;
  & .homecard {
    text-align: center;
    padding: 20px;
    border-radius: 4px;
    background: rgba(0, 178, 238, 0.1);
    height: 100%;
    & .cardicon {
      width: 100px;
      height: 100px;
      margin: auto;
      & img {
        width: 80px;
      }
    }
    & .h3 {
      font-size: 23px;
      line-height: 32px;
      color: #CC0099;
      text-align: left;
      @media (max-width: 400px) {
        font-size: 20px;
      }
    }
  }
}

.homequote {
  text-align: center;
  font-size: 24px;
  line-height: 32px;
  font-style: italic;
  color: #666;
  max-width: 600px;
  margin: 20px auto;
}
</style>

